import { useEffect } from "react";

import { useOutletContext } from "@zenith/context";
import { useLoadOutlets } from "@zenith/features/OutletManagement/hooks/useLoadOutlets";

/**
 * Loads the outlets whenever the outlet context has none resolved: on mount, and
 * again after signing in, logging out or a token invalidation clears it. Screens
 * wait on the outlet view, so this must run whether or not the switcher is shown.
 */
export const useKeepOutletsLoaded = () => {
  const { outletContext, setOutletContext } = useOutletContext();
  const { outlets, isLoadingOutlets } = outletContext;
  const loadOutlets = useLoadOutlets();

  useEffect(() => {
    if (!isLoadingOutlets || outlets.length > 0) return;
    loadOutlets().catch((error) => {
      console.error("Failed to fetch outlets:", error);
      setOutletContext({ isLoadingOutlets: false });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingOutlets, outlets.length, loadOutlets]);
};
